// ─── Route Paths ────────────────────────────────────────────────────────────
export const ROUTE_PATHS = {
  HOME: '/',
  WEB_DESIGN: '/servicii/web-design',
  CALL_CENTER: '/servicii/call-center',
  IT_HARDWARE: '/servicii/it-hardware',
  HOSTING: '/servicii/gazduire',
  VOIP: '/servicii/telefonie-voip',
  CRM_SOFTWARE: '/servicii/crm-software',
  CONTACT: '/contact',
  CLIENTS: '/clienti',
  TERMENI: '/termeni',
  CONFIDENTIALITATE: '/confidentialitate',
  RETUR: '/retur',
  NDA: '/nda',
  COOKIES: '/cookies',
  BLOG: '/blog',
  BLOG_CATEGORY: '/blog/:category',
  BLOG_ARTICLE: '/blog/:category/:slug',
  CART: '/cart',
  CHECKOUT: '/checkout',
  LOGIN: '/cont',
  CLIENT_PORTAL: '/portal',
} as const;

// ─── Types ──────────────────────────────────────────────────────────────────
export interface Service {
  id: string;
  slug: string;
  titleRo: string;
  titleEn: string;
  shortDescRo: string;
  shortDescEn: string;
  longDescRo: string;
  longDescEn: string;
  icon: string;
  image: string;
  features: { ro: string; en: string }[];
  route: string;
}

export interface Stat {
  value: string;
  labelRo: string;
  labelEn: string;
}

export interface Testimonial {
  name: string;
  role: string;
  company: string;
  textRo: string;
  textEn: string;
  avatar: string;
}

export type Lang = 'ro' | 'en';

// ─── Utility ─────────────────────────────────────────────────────────────────
export function cn(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}
